import Header from './header';
import Footer from './footer';
import DialogInternal from './dialog-internal';
import CloseButton from './close-button';
import Button from './button';
import Body from './body';
var DialogNamespace = Object.assign(DialogInternal, {
    Header: Header,
    Body: Body,
    Footer: Footer,
    Button: Button,
    CloseButton: CloseButton,
});
export default DialogNamespace;
